import BindSubcategories from "../symbols/bindSubcategories";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

function BindSubcategoriesReducer(state = initialState, action: any) {
  switch (action.type) {
    case BindSubcategories.BIND_SUBCATEGORIES:
      return { ...state, loading: true, error: false };
    case BindSubcategories.BIND_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case BindSubcategories.BIND_SUBCATEGORIES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case BindSubcategories.CLEAR_BIND_SUBCATEGORIES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default BindSubcategoriesReducer;
